import { Layout, SectionTitle } from "@/components/Layout";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle, Clock, ShieldCheck, Zap } from "lucide-react";

export default function SupportPage() {
  const { openWhatsApp } = useSettings();
  const feats = [
    { icon: Zap, title: "Atendimento rápido", text: "Resposta ágil pelo WhatsApp oficial." },
    { icon: ShieldCheck, title: "Suporte confiável", text: "Equipe especializada em configuração." },
    { icon: Clock, title: "Disponível sempre", text: "Ajuda quando você precisar." },
  ];
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-8 py-14">
        <SectionTitle center label="Suporte" title="Precisa de ajuda?"
          subtitle="Nossa equipe está pronta para configurar seu dispositivo junto com você." />
        <div className="grid gap-5 sm:grid-cols-3 mb-10">
          {feats.map((f) => (
            <div key={f.title} className="ci-card p-6 text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-600/10 border border-cyan-400/20 flex items-center justify-center mb-3">
                <f.icon className="w-6 h-6 text-cyan-300" />
              </div>
              <h3 className="font-semibold mb-1">{f.title}</h3>
              <p className="text-sm text-gray-400">{f.text}</p>
            </div>
          ))}
        </div>
        <div className="text-center">
          <button onClick={() => openWhatsApp("support-page")} data-testid="support-whatsapp-btn"
            className="ci-btn-wa inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-bold text-lg hover:brightness-110 transition">
            <MessageCircle className="w-5 h-5" /> FALAR NO WHATSAPP
          </button>
        </div>
      </div>
    </Layout>
  );
}
